/**
 * Namespaced so we don't pollute the global intellisense namespace with a billion generically named constants
 */
export namespace RouteConfigurationServiceDomain {
    /**
     * Allows for identification of origin based one minimal identifying subset of the origin string
     */
    export enum OriginIdentifier {
        // covers zillowhomeloans.com, dev.zillowhomeloans.net, and staging.zillowhomeloans.net
        ZILLOW_HOME_LOANS = 'zillowhomeloans',
        // covers qa.zillow.com, zillow.com. The period is important to distinguish it from zillow-dev-k8s or zillow-test-k8s
        ZILLOW = 'zillow.',
        LOCALHOST = 'localhost',
        ZGCP = 'zhl-mortgage-application-center-web-',
    }

    export enum ZillowDomain {
        NON_PRODUCTION = 'https://www.qa.zillow.net',
        PRODUCTION = 'https://www.zillow.com',
    }

    export enum ZillowHomeLoansLegacyDomain {
        DEVELOPMENT = 'https://www.dev.zillowhomeloans.net',
        STAGING = 'https://www.staging.zillowhomeloans.net',
        PRODUCTION = 'https://www.zillowhomeloans.com',
    }

    /**
     * Contains all routes for our application experiences
     * ! Careful changing these routes, as the blast radius is huge
     */
    export enum ApplicationRoute {
        MISSING_DASHBOARD = '/homeloans/mortgage/dashboard/not-found',
        AUTH_LOGIN = '/homeloans/mortgage/auth/login',
        AUTH_ERROR = '/homeloans/mortgage/auth/error',
        DASHBOARD = '/homeloans/mortgage/dashboard',
        DASHBOARD_BOUNCE = '/homeloans/mortgage/dashboard/login',
        ACTIVATE = '/homeloans/mortgage/dashboard/activate',
        ACTIVATE_FAILURE = '/homeloans/mortgage/dashboard/activation-failure',
        AUTH_SIGNIN_BOUNCE = '/homeloans/mortgage/auth/signin',
        CALLBACK_SCHEDULER = '/homeloans/mortgage/schedule-callback',
        CALLBACK_SCHEDULER_SUCCESS = '/homeloans/mortgage/schedule-callback/success',
        CALLBACK_SCHEDULER_FAILURE = '/homeloans/mortgage/schedule-callback/failure',
        CALLBACK_SCHEDULER_ERROR = '/homeloans/mortgage/schedule-callback/error',
        BLEND_AUTH_TELEMETRY = '/homeloans/mortgage/auth/blend',
        API_BASE = '/homeloans/mortgage/api',
        PREFIXED_GRAPHQL_ENDPOINT = '/homeloans/mortgage/api/graphql',
        PREFIXLESS_GRAPHQL_ENDPOINT = '/api/mortgage/graphql',
    }

    /**
     * External routes are routes that are not handled by this application.
     */
    export enum ExternalRoute {
        FIRST_PARTY_PREAPPROVAL_APPLICATION = '/homeloans/quickapp/',
        PREQUAL_FUNNEL = '/homeloans/eligibility',
        HOMELOANS_LANDING_PAGE = '/homeloans/',
        UNIVERSAL_LOGOUT = '/Logout.htm',
        FIRST_PARTY_APPLICATION = '/quickapp/',
        /**
         * These routes are here to enable the MAC Web auth client to be re-used by the ZHL Lead Ingress Web
         * service while the ZHL Auth consolidation is in development byu CIAM. These are used as an allowlist
         * of acceptable "non-MAC Web" redirect destinations from the signin bounce page.
         */
        HOMELOANS_APPLY = '/homeloans/apply/',
        HOMELOANS_APPLY_CONTACT_PAGE = '/homeloans/apply/contact/',
    }

    /**
     * Allowlist of external callback URLs that are safe to redirect to after authentication.
     * This prevents infinite loops when the signin bounce page redirects to itself and provides
     * security by limiting where users can be redirected after authentication.
     */
    export const ALLOWED_EXTERNAL_CALLBACK_URLS: ExternalRoute[] = [
        ExternalRoute.HOMELOANS_APPLY,
        ExternalRoute.HOMELOANS_APPLY_CONTACT_PAGE,
    ];
}
